<template>
  <div class="hy-index">
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title">  近期重要活动</h5>
        <van-list>
          <van-cell v-for="item in tuiList" :key="item.id">
            <a class="more-link" :href="'/index/conference/template?id='+item.gid">
              <div class="imgbox">
                <img :src="item.spread.cover_url" alt />
                <span class="text_icon" v-if="item.spread.status_str == '待发布'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_yellow" v-if="item.spread.status_str == '已发布' || item.spread.status_str == '报名中'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.spread.status_str == '会议中'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="item.spread.status_str == '已结束'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.spread.status_str == '未到报名时间'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.spread.status_str == '报名截止'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{item.spread.status_str }}</span>
                <!-- <span class="text_icon icon_black">已结束</span> -->
                <!-- <span class="text_icon icon_blue">活动中</span> -->
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{item.spread.name}}</h5>
                  <span class="type"  v-if="item.spread.type == 1">会议</span>
                  <span class="type"  v-else-if="item.spread.type == 2">沙龙</span>
                  <span class="type"  v-else-if="item.spread.type == 3">活动</span>
                  <!-- <span class="type">活动</span> -->
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe67f;</span>
                  {{item.spread.start_time,'Y-M-D'|formatDates}}~{{item.spread.end_time,'Y-M-D'|formatDates}}
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe64d;</span>
                  {{item.spread.region}}&nbsp;{{item.spread.specific_address}}
                </div>
              </div>
            </a>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <router-link class="nav-link iconfont" to="/">
          &#xe60e;
          <span class="text">会议平台首页</span>
        </router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
  </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDates } from "../../assets/js/date"
export default {
  data() {
    return {
      searchValue: "",
      tuiList: [],
      footerNav: false
    };
  },
  created() {
    var _this = this;
    _this.list();
    _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:''});
  },
  /* 时间过滤 */
  filters: {
    formatDates
  },
  methods: {
    //热门咨询加载
    /* 初始化数据列表 */
    list(page, pagesize) {
      var _this = this;
      let url = "/ac1/conference/index";
      let params = {
        page: 1,
        pagesize: 2
      };
      _this.$get(url, params).then(res => {
        if (res.code == "1") {
          _this.tuiList = res.posts.recommended;
        }
      });
    },
    //打开底部链接
    openFooterNav(val) {
      if (this.footerNav) {
        this.footerNav = false;
      } else {
        this.footerNav = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
</style>
